<template>
    <div>
        <el-dialog
            title="商户标签"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <div class="formContent">
                <el-checkbox-group v-model="tagList">
                    <el-checkbox :label="1">资方</el-checkbox>
                </el-checkbox-group>
            </div>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                tagList: [],
                companyId: '',
            };
        },
        methods:{
            submit () {
                let reqData = {
                    companyId: this.companyId,
                    invest: this.tagList.indexOf(1) != -1 ? 1 : 0
                }
                this.$confirm('是否确认提交？', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(_=>{
                    this.$Axios._post({
                        url: this.$Config.apiUrl.addCompanyInvest,
                        params: reqData,
                    })
                    .then(res => {
                        this.dialogVisible = false
                        this.$emit('change')
                        this.$message.success('操作成功')
                    })
                    .catch((error) => {
                        this.$message.error(error.result.message)
                    });
                }).catch(_=>{ })
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>